<template>
  <div class="platform-info-edit-wrp ft-12">
    <el-form
      class="form"
      :model="self_form"
      :rules="rules"
      ref="form"
      label-width="12%"
    >
      <slot name="errMsg"></slot>
      <section>
        <div class="title ft-12">
          <span>类目选择</span>
        </div>
        <div class="conf">
          <el-form-item label="商品分类：" prop="categoryIds">
            <div class="category ft-12">
              <category-input
                ref="cinput"
                v-model="self_form.categoryIds"
                :platform="platform"
                :isSupportAi="true"
              />
            </div>
          </el-form-item>
        </div>
      </section>
      <section>
        <div class="title ft-12">
          <span>基础信息</span>
        </div>
        <div class="conf">
          <el-form-item label="引用套图:" v-if="showGroupImages">
            <div class="ft-12">商品资料已维护套图，电商平台图片可以使用已维护套图快速填充 <el-link @click="editGroupImages">维护套图</el-link> </div>
            <GroupImagesList :baseItemId="baseItemId" @useOk="useGroupImages" :specifications="specifications" :hideImgs="['mainImages34']" @getList="getGroupImagesList"></GroupImagesList>
          </el-form-item>
          <el-form-item label="商品图片：" prop="headImgs">
            <div class="imgs-wrp">
              <div class="ft-12">铺货时只取主图，拖动可调整顺序<BatchEditImages v-model="self_form.headImgs" refName="headImgs" :getWidthAndHeights="getWidthAndHeights"></BatchEditImages></div>
              <MutiImgUpload
                ref="headImgs"
                v-model="self_form.headImgs"
                :limitSize="10 * 1024 * 1024"
                :limitNums="9"
                :size="300"
                :mainImgNums="0"
                limitSuffix=".jpg,.png,.jpeg"
                :supportAiRetry="true"
              />
              <div class="tips ft-12">
                <p>
                  <span>至少上传3张图片，最多上传9张图片，单张图片需限制在10M以内</span>
                </p>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="商品视频：" prop="videoId">
            <el-row type="flex" align="middle">
              <VideoUpload style="text-align: left;" @upload-success="videoUploadSuccess" :video="videoInfo" limitSuffix=".mp4" @del="videoDel"/>
            </el-row>
          </el-form-item>
          <el-form-item label="商品标题：" prop="title">
            <el-input
              type="text"
              placeholder="请输入"
              v-model="self_form.title"
              maxlength="60"
              show-word-limit
            >
            </el-input>
          </el-form-item>
          <el-form-item label="短标题：" prop="shortTitle">
            <el-input
              type="text"
              placeholder="请输入"
              v-model="self_form.shortTitle"
              maxlength="20"
              show-word-limit
            >
            </el-input>
          </el-form-item>
          <el-form-item label="商品描述：" prop="subTitle">
            <el-input
              type="text"
              placeholder="请输入"
              v-model="self_form.subTitle"
              maxlength="18"
              show-word-limit
            >
            </el-input>
          </el-form-item>
          <el-form-item label="品牌：" prop="brandId">
            <BrandIdBlock
              ref="BrandIdBlockRef"
              v-model="self_form.brandConfig"
              :shopList="shopList"
              :baseItemId="baseItemId"
              :categoryId="categoryId"
              />
              <!-- <div class="tips ft-12">
                <span>如未找到需要的品牌，可提供品牌商标申请品牌</span>
                <a target="_blank" href="">点击申请</a>
              </div> -->
          </el-form-item>
          <div>
            <div style="width: 12%; text-align: right; color: #606266;">商品资质：</div>
            <div style="padding: 10px 0px 0px 12%;">
              <span v-for="item in productQuaInfoAttrs" :key="item.quaId">
                <el-form-item :label="item.name" :prop="`quaId_${item.quaId}`">
                  <div><BatchEditImages v-model="self_form[`quaId_${item.quaId}`]" :refName="`quaId_${item.quaId}`" :getWidthAndHeights="getWidthAndHeights"></BatchEditImages></div>
                  <div class="imgs-wrp">
                    <MutiImgUpload
                      :ref="`quaId_${item.quaId}`"
                      v-model="self_form[`quaId_${item.quaId}`]"
                      :limitSize="2 * 1024 * 1024"
                      :limitNums="10"
                      :mainImgNums="0"
                      :size="150"
                      limitSuffix=".jpg,.png,.jpeg"
                    />
                  </div>
                </el-form-item>
                <el-form-item v-if="item.tips">
                  <div class="tips ft-12" v-html="handleTip(item.tips)"> </div>
                </el-form-item>
              </span>
            </div>
          </div>
          <!-- <el-form-item label="商品资质图片：" prop="qualifications">
            <div><BatchEditImages v-model="self_form.qualifications" refName="qualifications" :getWidthAndHeights="getWidthAndHeights"></BatchEditImages></div>
            <div class="imgs-wrp">
              <MutiImgUpload
                ref="qualifications"
                v-model="self_form.qualifications"
                :limitSize="2 * 1024 * 1024"
                :limitNums="5"
                :mainImgNums="0"
                :size="150"
                limitSuffix=".jpg,.png,.jpeg"
              />
            </div>
          </el-form-item> -->
        </div>
      </section>
      <section>
        <div class="title ft-12">
          <span>规格售价与库存</span>
        </div>
        <div class="conf">
          <el-form-item v-if="!self_form.pureType" label="商品规格：">
            <RuleSortBtn :specifications.sync="specifications" />
            <SpecsValuesSort :specifications.sync="specifications" />
            <FormItemSpecification
              v-model="specifications"
              :changeToBase="changeToBase"
              :isPlatform="true"
              :platform="platform"
              imgLimitSuffix=".jpg"
            />
          </el-form-item>
          <el-form-item v-if="!self_form.pureType" label="规格明细：">
            <FormItemSkuList
              :specifications="specifications"
              :baseItemId="self_form.baseItemId"
              skuSpecificationsKey="skuSpecifications"
              :tableCols="skuTableCols"
              v-model="skuList"
              @fieldChanged="validPage"
            >
              <div class="stockType-desc" slot="deliverInfoSlot" slot-scope="{ row }">
                <span>
                  {{ formatStockDescription(row) }}
                </span>
                <template v-if="allowedPreSale">
                  <el-link :underline="false" @click="handleEditStockType(row)">修改</el-link>
                </template>
              </div>
              <template v-if="allowedPreSale" slot="skuBatchSlot">
                <el-button @click="handleEditStockType({}, true)">批量编辑发货</el-button>
              </template>
            </FormItemSkuList>
            <template v-if="specificationsValidResult !== true">
              <div class="el-form-item__error">{{specificationsValidResult}}</div>
            </template>
          </el-form-item>
          <el-form-item label="商品商家编码" prop="spuCode">
            <el-input
              type="text"
              placeholder="请输入"
              v-model="self_form.spuCode"
            >
            </el-input>
          </el-form-item>
        </div>
      </section>
      <section>
        <div class="title">
          <span>商品详情说明</span>
        </div>
        <div class="conf">
          <el-form-item label="商品详情" prop="descInfo">
            <div><BatchEditImages v-model="self_form.descInfo" refName="descInfo" :getWidthAndHeights="getWidthAndHeights"></BatchEditImages></div>
            <MutiImgUpload
              ref="descInfo"
              v-model="self_form.descInfo"
              :limitSize="10 * 1024 * 1024"
              :limitNums="50"
              :size="300"
              :mainImgNums="0"
              limitSuffix=".jpg,.png,.jpeg,.bmp,.gif,.svg"
              :supportAiRetry="true"
            />
            <div class="tips ft-12">
              <p>
                <span>至少上传1张图片，最多上传50张图片，单张图片需限制在10M以内<a href="https://docs.qq.com/doc/DTmZJQlVveVFxZUNP" target="_blank">商品详情发布规范</a></span>
              </p>
            </div>
          </el-form-item>
        </div>
      </section>
      <section>
        <div class="title">
          <span>类目属性</span>
        </div>
        <div class="conf">
          <el-form-item
            label="商品属性"
            prop="productFormat"
          >
            <UseCategoryTemplate 
              :categoryIds="self_form.categoryIds" 
              :detailHasCategory="detailHasCategory" 
              :detailId="self_form.id" 
              :platform="platform" 
              :baseItemId="baseItemId" 
              :propValues="self_form.productFormat"
              @clickFill="clickTemPlateFill"
              >
              <CategoryProps
                ref="cateprops"
                v-model="self_form.productFormat"
                :categoryIds="self_form.categoryIds"
                @props-update="handlePropsUpdate"
              />
            </UseCategoryTemplate>
          </el-form-item>
        </div>
      </section>
      <!-- 运费模板 -->
      <section>
        <div class="title ft-12">
          <span>运费模板</span>
        </div>
        <div class="conf">
          <el-form-item label="发货方式:" prop="deliverMethod">
            <el-radio-group v-model="self_form.deliverMethod">
                <el-radio :label="0">快递发货</el-radio>
                <el-radio :label="1">无需快递</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="self_form.deliverMethod === 0" label="运费设置：">
            <el-row v-if="shopList.length && shipsValue">
              <el-col v-for="shop in shopList" :key="shop.id" :span="12" class="set-ship">
                <el-image :src="shop.icon" style="width: 26px; height: 26px;  border-radius: 50%"></el-image>
                <el-tooltip v-if="shop.channelIcon" :content="shop.channelName" style="margin: 0px -6px 0px 6px;">
                  <el-image :src="shop.channelIcon" style="width: 18px; height: 18px;"></el-image>
                </el-tooltip>
                <span class="shop-title">{{ shop.shortTitle || shop.title}}</span>
                  <el-select 
                    v-model="shipsValue[shop.id]" 
                    placeholder="请选择运费模板"
                    :loading="shipsTemplateLoadings[shop.id]"
                    value-key="templateId"
                    clearable
                    @visible-change="getTemplateList(shop.id, shop.userId)"
                    >
                    <el-option
                      v-for="ship in shipsTemplate[shop.id]"
                      :key="ship.templateId"
                      :label="ship.templateName"
                      :value="ship"
                      >
                    </el-option>
                  </el-select>
                </el-col>
            </el-row>
            <span v-else class="no-shops">暂无平台店铺</span>
            <div style="font-size: 12px;color: #E6A23C;">tips：建议您提前在平台后台配置好运费模板，并在上方选择设置店铺的运费模板，否则可能会导致平台铺货失败</div>
          </el-form-item>
          <el-form-item label="重量:" prop="weight">
            <el-input-digit
              v-model.number="self_form.weight"
              placeholder="请输入重量"
              nullable
              :precision="3"
              style="width: 150px; margin-left: 10px;"
            >
              <span>kg</span>
            </el-input-digit>
          </el-form-item>
        </div>
      </section>
      <!-- 上架设置 -->
      <section>
        <div class="title ft-12">
          <span>上架设置</span>
        </div>
        <div class="conf">
          <el-form-item 
            label="上架设置:"
            prop="isOnshelf" 
            :rules="[{required: true, message: '请输入上架设置', trigger: 'blur'}]">
              <el-radio-group v-model="self_form.isOnshelf">
                  <el-radio :label="1">立即上架</el-radio>
                  <el-radio :label="2">放入草稿箱</el-radio>
              </el-radio-group>
          </el-form-item>
        </div>
      </section>
      <section>
        <div class="title">
          <span>更多设置</span>
        </div>
        <div class="conf">
          <el-form-item 
            prop="sevenDayReturn" 
            :rules="[{required: sevenDayReturnOptions.length == 2, message: '请选择七天无理由'}]"
          >
            <span slot="label">
              七天无理由
              <el-tooltip effect="dark" content="当商品满足相应条件时，用户可在收货后7天内，符合条件的情况下，可申请”7天无理由退货“，商家不得以其他理由拒绝用户申请。" placement="top-start">
                <i class="el-icon-warning-outline" />
              </el-tooltip>
              ：
            </span>
            <el-select 
              v-model="self_form.sevenDayReturn" 
              placeholder="请选择"
              clearable
              >
              <el-option
                v-for="sevenOption in sevenDayReturnOptions"
                :key="sevenOption.value"
                :label="sevenOption.label"
                :value="sevenOption.value"
                >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="限购：" prop="limitState">
            <el-switch
              v-model="self_form.limitState"
              :active-value='1'
              :inactive-value='0'
            >
            </el-switch>
            <div style="color: #606266;font-size:12px;margin-top: 6px;" v-show="self_form.limitState">
              每人            
              <el-select 
                v-model="self_form.limitInfoConfig.periodType" 
                placeholder="请选择"
                clearable
                style="width:80px;"
              >
                  <el-option label="每日" :value="1" />
                  <el-option label="每周" :value="2" />
                  <el-option label="每月" :value="3" />
                  <el-option label="每年" :value="4" />
              </el-select>
              限购
              <el-input-digit
                v-model.number="self_form.limitInfoConfig.limitedBuyNum"
                placeholder="请输入"
                nullable
                :precision="0"
                style="width: 60px; margin-left: 4px;"
              >
              </el-input-digit>
            </div>
          </el-form-item>
          <el-form-item label="假一赔三:" prop="fakeOnePayThree" >
            <el-radio-group v-model="self_form.fakeOnePayThree">
                <el-radio :label="1">支持</el-radio>
                <el-radio :label="0">不支持</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否支持坏损包退:" prop="damageGuarantee" >
            <el-radio-group v-model="self_form.damageGuarantee">
                <el-radio :label="0">不支持坏损包退</el-radio>
                <el-radio :label="1">支持坏损包退</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="换货:" prop="exchangeSupport" >
            <el-radio-group v-model="self_form.exchangeSupport">
                <el-radio :label="0">不支持换货</el-radio>
                <el-radio :label="1">支持换货</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="运费险:" prop="freightInsurance" >
            <el-radio-group v-model="self_form.freightInsurance">
                <el-radio :label="0">不支持运费险</el-radio>
                <el-radio :label="1">支持运费险</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 退货地址配置 -->
          <el-form-item label="退货地址:" :rules="[{ required: true, validator: validateAddress, trigger: 'change' }]" prop="returnAddressSet" label-width="120px">
            <el-row class="ship-wrp" style="display:inline-block;" v-if="shopList.length && Object.keys(returnAddressValue).length">
              <div class="item" v-for="(item, idx) in shopList" :key="idx">
                <el-col class="set-ship">
                  <el-image :src="item.icon" style="height: 26px; border-radius: 50%;"></el-image>
                  <el-tooltip v-if="item.channelIcon" :content="item.channelName" style="margin: 0px -6px 0px 6px">
                    <el-image :src="item.channelIcon" style="width: 18px; height: 18px; overflow: unset; top: 4px"></el-image>
                  </el-tooltip>
                  <span class="shop-title">{{ item.shortTitle || item.title }}</span>
                </el-col>
                <el-col>
                  <el-select
                    v-if="returnAddressValue[item.id]"
                    :loading="!!selectLoading[item.id]"
                    loading-text="加载中..."
                    v-model="returnAddressValue[item.id].addressId"
                    placeholder="请选择退货地址"
                    clearable
                    filterable
                    @change="handleReturnAddressChange(item.id, $event)"
                    @visible-change="visible => visibleChangeReturnAddress(item.id, item.userId, visible)"
                    width="500px"
                  >
                    <el-option
                      v-for="addr in (returnAddressTemplate[item.id] || [])"
                      :key="addr.addressId"
                      :label="addr.addressName"
                      :value="addr.addressId"
                      style="width: 500px"
                    >
                    </el-option>
                  </el-select>
                </el-col>
              </div>
            </el-row>
            <span v-else class="no-shops">暂无平台店铺</span>
          </el-form-item>
        </div>
      </section>
    </el-form>
    <!-- 选择发货方式  -->
    <DialogSelectStockType ref="dialogSelectStockType" @on-success="handleSelectStockTypeSuccess" />
  </div>
</template>
<script>
import "@/assets/css/prod.scss";
import MutiImgUpload from "@/components/Uploads/MutiImgUpload";
import BatchEditImages from '@/components/prod/center/components/BatchEditImages.vue'
import GroupImagesList from '@/components/prod/center/BasicComps/GroupImages/list.vue'
import CategoryInput from "../PlatformCategoryInput/index.vue";
import ReuseLastCategory from "../PlatformCategoryInput/ReuseLastCategory.vue";
import DialogSelectStockType from './components/DialogSelectStockType.vue';
import CategoryProps from './CategoryProps.vue';
import BrandIdBlock from './components/BrandIdBlock.vue';
import UseCategoryTemplate from '../UseCategoryTemplate.vue'
import VideoUpload from '@/components/Uploads/videoUpload'

import RULES from "./rules.js";

import { specification_mixin } from "../FormItemSpecification";
import {
  getDistributionConfig,
  getWxsphTemplateList,
  getWxsphAddressList,
} from "@servers/prod/conf/index.js";
import validateMixin from '../validateMixin';
import shopListMixin from '../shopListMixin';
import { mapGetters } from "vuex"
import { cloneDeep } from 'lodash';
import { processAddressItems,editCarouselVideo } from '@/servers/prod/center/wxh'
import {getVideoInfo} from '@api/base/index.js';

const sevenDayReturnOptionDefault = [
  {value: 1, label: '支持七天无理由'},
  {value: 2, label: '支持七天无理由（定制商品除外）'}
];

const sevenDayReturnOptionAll = [
  {value: 0, label: '不支持七天无理由'},
  ...sevenDayReturnOptionDefault
]

export default {
  mixins: [specification_mixin, validateMixin, shopListMixin],
  provide(){
    return {
      platform: "wxsph",
      openSource:this.openSource
    }
  },
  inject: {
    isGroupPuhuo: { default: false },
  },
  components: {
    MutiImgUpload,
    BatchEditImages,
    GroupImagesList,
    CategoryInput,
    ReuseLastCategory,
    CategoryProps,
    BrandIdBlock,
    DialogSelectStockType,
    UseCategoryTemplate,
    VideoUpload,
  },
  props: {
    form: {
      type: Object,
      default() {
        return {};
      },
    },
    rowData: {
      type: Object,
      default: () => ({})
    },
    shopsList: {
      type: Array,
      default: ()=> {
        return []
      }
    },
    baseItemId: [Number, String],
    changeToBase: Function,
    openSource:{
      type:String,
      default:''
    },
  },
  data() {
    return {
      sevenDayReturnOptions: [
        ...sevenDayReturnOptionAll,
      ],
      isWxh: true,
      platform: "wxsph",
      self_form: {},
      rules: RULES(this),
      showGroupImages: true,
      skuSpecificationsKey: "skuSpecifications",
      skuImgOnlyPreview: true, // sku的预览图是否只能预览不能编辑
      specification_needImg: false, // 规格需要校验图片是否补充
      categoryId: '',
      detailCategoryId: '',
      detailCategoryIdChange: false,
      detailHasCategory: [],
      productQuaInfoAttrs: [],
      // brandList: [],
      shipsTemplate: {}, // 运费模板列表
      shipsValue: null, // 运费模板值
      originalTemplateConfig: null,
      shipsTemplateLoadings: {},
      allowedPreSale: null, // 类目是否支持预售
      editRowData: null,
      deliverInfoDialog: { batch: false },
      returnAddressValue: {}, // 退货地址值
      returnAddressTemplate: {}, // 退货地址模板列表
      returnAddressTemplateCaches: {}, // 退货地址模板
      selectLoading: {}, // 退货地址加载状态 per-shop
      isNeedBarCode:false,// sku条形码是否必填
      videoInfo:null
    };
  },
  computed: {
    ...mapGetters(['shops_getCategoryPropShopId']),
    shopList() {
      let list = this.getShopList(this.platform);
      if(this.openSource === 'shopGoods'){
          list = list.filter(item => item.id == this.form.shopId)
      }
      return list;
    },
    shopId() {
      return this.shops_getCategoryPropShopId(this.platform)
    },
    skuTableCols() {
      const cols = [
        {prop: 'salePrice', attrs: {label: '售卖价'}, input: {type: 'number'}, previewPrice: false, previewPriceType: 'sales'},
        {prop: 'marketPrice', attrs: {label: '市场价', noRequired: true}, input: {type: 'number'}, previewPrice: false, previewPriceType: 'market'},
        { prop: 'skuSupplyPrice', attrs: { label: '供货价',noRequired: true },unvisible:JSON.parse(localStorage.getItem('_origin_form'))?.isDistribution == 0? true : false  },
        {prop: 'stockNum', attrs: {label: '库存'}, input: {type: 'number'},  disabledFn: (row) => {
          return (this.form?.pureType || row.stockType === 1)
        }},
        {prop: 'deliverInfo', attrs: {label: '发货方式'}, slot: true},
        {prop: 'barCode', attrs: {label:'条形码',requiredFn: () => this.isNeedBarCode},input: {type: 'text'}},
        this.openSource != 'shopGoods' ? {prop: 'platformSkuCode',input: {type: 'text'},attrs: {label: 'sku编码',noRequired: true,width:180,headerTooltip: '平台规格编码，对应平台sku外部商家编码，用于管理商品，并匹配ERP商品'}} : null,
        this.openSource != 'shopGoods' ? {prop: 'skuCode', input: {type: 'text'},attrs: {label: '基础资料商品编码',width:180, noRequired: this.isGroupPuhuo, headerTooltip: this.isGroupPuhuo ? '' : '必填，用于关联基础资料规格明细'}} : null,
      ]
      return cols.filter(Boolean)
    },
  },
  watch: {
    form: {
      handler(formData) {
        const v = cloneDeep(formData);
        if (v.skuList?.length) {
          v.skuList = v.skuList.map((item) => {
            const _skuid = item[this.skuSpecificationsKey].map((sp) => sp.valueKey).filter(Boolean).join("-");
            return {
              ...item,
              _skuid,
            };
          });
        }
        this.skuList = []
        if (v.specifications && v.specifications.length) {
          this.specifications = JSON.parse(JSON.stringify(v.specifications));
        }
        if (v.templateConfig && v.templateConfig.length) {
            this.originalTemplateConfig = cloneDeep(v.templateConfig);
        }
        if(v.limitInfoConfig){
          try{
            v.limitInfoConfig = JSON.parse(v.limitInfoConfig)
          }catch(e){console.log(e)}
        }else{
          v.limitInfoConfig =  {periodType:null,limitedBuyNum:null}
        }
        this.detailHasCategory = v.categoryIds || []
        this.detailCategoryId = v.categoryIds ? v.categoryIds[v.categoryIds.length - 1] : '';
        if(v.videoId){
          this.getVideoInfoById(v.videoId)
        }
        this.$set(this, "self_form", v);
        this.$nextTick(() => {
          this.validPage();
        });
      },
      immediate: true,
    },
    'self_form.categoryIds': {
      handler(v) {
          if(v && v.length) {
            this.categoryId = v[v.length - 1]
            if(this.detailCategoryId != this.categoryId || this.detailCategoryIdChange){
              this.detailCategoryIdChange = true
              this.$nextTick(() => {
                  this.$refs.BrandIdBlockRef?.useBrandConfInit();
              });
            }
          }
      },
      immediate: true
    },
    shopList: {
      handler(newList) {
        if (!newList || !newList.length) return;
        newList.forEach(shop => {
          if (!this.returnAddressValue[shop.id]) {
            this.$set(this.returnAddressValue, shop.id, {
              shopId: shop.id,
              addressId: '',
              addressName: ''
            });
          }
        });
      },
      immediate: true,
    },
  },
  methods: {
    handleTip(tip) {
      return tip.replace(/\n\n/g, '</br>')
    },
    getWidthAndHeights(refName) {
      return this.$refs[refName].getWidthAndHeights ? this.$refs[refName].getWidthAndHeights() : []
    },
    validateAddress(rule, value, callback) {
      const hasValidAddress = this.returnAddressValue &&  Object.values(this.returnAddressValue).some(item =>item && item.addressId);
      if (!hasValidAddress) {
        callback(new Error('请选择售后地址'));
      } else {
        callback();
      }
    },
    method_getFormData(cb) {
      return new Promise((resolve, reject) => {
        this.validPage().then(async (valid) => {
          if (!valid) {
            this.$message.error('请完善表单')
            resolve(false)
            return;
          }

          // 校验规格名称长度
          // const hasInvalidNameLength = this.specifications.some(spec => {
          //   return spec.values.some(value => {
          //     if (value.value && value.value.length > 3) {
          //       this.$message.error(`规格名称 "${value.value}" 长度不能超过40个字符`);
          //       return true;
          //     }
          //     return false;
          //   });
          // });

          // if (hasInvalidNameLength) {
          //   resolve(false);
          //   return;
          // }

          const [specifications, skuList] = this.getSpecificationData();
          const c_names = this.$refs.cinput.method_getCategoryNames();
          let _formdata = JSON.parse(JSON.stringify(this.self_form));
          _formdata.specifications = JSON.parse(
            JSON.stringify(specifications)
          );
          _formdata.skuList = skuList.map((item) => {
            let _item = {
              ...item,
              imageUrl: item[this.skuSpecificationsKey][0].imageUrl,
              marketPrice: item.marketPrice || 0
            }
            delete _item._skuid
            return {
              ..._item
            }
          });                                                                                        
          _formdata.categoryId = _formdata.categoryIds[_formdata.categoryIds.length - 1];
          _formdata.categoryName = c_names[c_names.length - 1];
          _formdata.parentCategoryId = _formdata.categoryIds[_formdata.categoryIds.length - 2];
          _formdata.parentCategoryName = c_names[c_names.length - 2];
          _formdata.templateConfig = (() => {
              let current = JSON.parse(this.handleTemplateConfig());
              current = this.mergeHiddenShopData(current, this.originalTemplateConfig, this.shopList);
              return JSON.stringify(current);
          })();
          _formdata.shopId = this.shopId;
          _formdata.weight = _formdata.weight || 0;
          if(_formdata.limitState){
            _formdata.limitInfoConfig = JSON.stringify(_formdata.limitInfoConfig)
          }else{
            _formdata.limitInfoConfig = null
          }
          _formdata.afterSaleAddressConfig = this.handleAfterSaleAddressConfig();
          _formdata.productQuaInfos = this.handleProductQuaInfos(_formdata);
          // console.log(_formdata, '----_formdata---')
          // resolve(false)
          //   return;
          resolve(_formdata);
        });
      });
    },
    useGroupImages(data, type) {
      const {mainImages=[], detailImages=[], speImages=[]} = data
      let pic = [], description = [];
      if(type === 'add') {
        pic = [...this.self_form.headImgs].filter(Boolean)
        description = [...this.self_form.descInfo]
      }
      if(mainImages.length) {
        this.self_form.headImgs = [...pic, ...mainImages].filter(Boolean).slice(0, 9)
      }
      if(detailImages.length) {
        this.self_form.descInfo = [...description, ...detailImages].filter(Boolean).slice(0, 20)
      }
      const firstSpec = this.specifications[0];
      if (firstSpec && firstSpec.values && speImages.length) {
        firstSpec.values.forEach(specValue => {
          // 如果是新增模式且已有图片，则跳过
          if (type === 'add' && specValue.imageUrl) {
            return;
          }
          
          // 查找匹配的图片
          const matchedImage = speImages.find(img => img.name === specValue.value);
          if (matchedImage) {
            specValue.imageUrl = matchedImage.imgUrl;
          }
        });
      }
    },
    getGroupImagesList (list){
      this.showGroupImages = !!list?.length
    },
    editGroupImages(){
      this.changeToBase('openGroupImgs')
    },
    handleTemplateConfig() {
      const arr = Object.values(this.shipsValue).filter(item => item.templateId).map(item => {
        const channel = this.shopList.find(shop => shop.id == item.shopId)?.channel
        return {
          shopId: item.shopId,
          templateId: item.templateId,
          templateName: item.templateName,
          channel
        }
      })
      return JSON.stringify(arr);
    },
    // 处理快手详情 templateConfig
    async initTemplateConfig(templateList = []) {
      const templateConfig = this.self_form.templateConfig || []
      const shipsValue = {}
      
      const promises = this.shopList.map(async shop => {
        const defaultValue = {shopId: shop.id, templateId: '', templateName: ''}
        let findItem = templateConfig.find(item => item.shopId == shop.id)
        
        // 如果 self_form.templateConfig 中没找到，尝试从 templateList 中查找
        if (!findItem) {
          findItem = templateList.find(item => item.shopId == shop.id)
        }
        
        if (findItem) {
          // 确保模板列表已加载
          await this.getTemplateList(shop.id, shop.userId)
          const curShipOptions = this.shipsTemplate[shop.id] || []
          const findOption = curShipOptions.find((item) => item.templateId == findItem.templateId);
          
          if (!findOption) {
            // 如果没找到对应的模板选项，重置为空对象，回退到 defaultValue
            findItem = {}
          } else {
            // 补充 valuationType
            findItem.valuationType = findOption.valuationType
          }
        }
        
        shipsValue[shop.id] = {...defaultValue, ...findItem}
      });

      await Promise.all(promises);
      this.shipsValue = shipsValue
    },
    // 获取配置
    async getConf() {
      const res = await getDistributionConfig({ shopType: "wxsph" });
      // 运费模板
      this.initTemplateConfig(res?.templateList || []);
      const afterSaleAddressTemplateList = processAddressItems(res?.afterSaleAddressTemplateList || [])
      this.initReturnAddressTemplate(afterSaleAddressTemplateList || []);
    },
    // 获取模板
    async getTemplateList(shopId, userId) {
      const isAuthorized =  this.$store.getters.is_authorized_shop('wxsph', shopId)
      if(!isAuthorized || this.shipsTemplate[shopId]?.length) return
      this.$set(this.shipsTemplateLoadings, shopId, true)
      let list = await getWxsphTemplateList({
        offset: 0,
        limit: 100,
        searchUsed: false,
        userId,
      }) || [];

      const shopTempList = (list || []).map((ship) => {
        return {
          shopId,
          templateName: ship.templateName,
          templateId: ship.templateId.toString(),
          valuationType: ship.valuationType,
        };
      });
      this.$set(this.shipsTemplate, shopId, shopTempList);
      this.$set(this.shipsTemplateLoadings, shopId, false)
    },

    formatStockDescription(rowData) {
      const { deliverInfo = '' } = rowData;
      const parseDeliverInfo = JSON.parse(deliverInfo || '{}');
      const { stockType = 0 } = parseDeliverInfo;
      if (stockType === 0 || !this.allowedPreSale) {
        return '现货，发货时间跟随物流模板发货';
      }
      const { fullPaymentPresaleDeliveryType, fullPaymentPresaleDeliveryTime } = parseDeliverInfo;
      return `全款预售，${fullPaymentPresaleDeliveryType === 0 ? '付款' : '预售结束'}后${fullPaymentPresaleDeliveryTime}天内发货`;
    },
    handlePropsUpdate(config = {}) {
      const { attr = {}, productQuaInfo =[],isNeedBarCode } = config;
      const { preSale = false, sevenDayReturn } = attr || {};
      this.allowedPreSale = preSale;
      this.isNeedBarCode = !!isNeedBarCode  // 移除双重否定
      if (sevenDayReturn) {
        this.sevenDayReturnOptions = [
          ...sevenDayReturnOptionDefault
        ]
      } else {
        this.sevenDayReturnOptions = [
          ...sevenDayReturnOptionAll
        ]
      }
      this.productQuaInfoAttrs = productQuaInfo || []
      this.productQuaInfoAttrs.forEach(item => {
        const findItem = this.self_form.productQuaInfos?.find(p => p.qua_id === item.quaId) || {}
        this.$set(this.self_form, `quaId_${item.quaId}`, findItem.qua_url || [])
        if(item.mandatory === 'true') {
          this.$set(this.rules, `quaId_${item.quaId}`, [
            { required: true, message: '请上传图片', trigger: 'blur' },
            { validator: async (rule, value, callback) => {
              if(!this.$refs[`quaId_${item.quaId}`]) {
                return callback();
              }
              let errMsg = await this.$refs[`quaId_${item.quaId}`][0].method_validImage()
              if (errMsg) {
                  callback(new Error(errMsg));
              } else {
                  callback();
              }
            }, trigger: 'blur' }
          ])
        }
      })
    },
    handleEditStockType(rowData, batch = false) {
      this.editRowData = rowData;
      this.deliverInfoDialog.batch = batch;
      const { deliverInfo } = rowData;
      const parseDeliverInfo = JSON.parse(deliverInfo || '{}');
      const { stockType = 0, fullPaymentPresaleDeliveryType = null, fullPaymentPresaleDeliveryTime = null, presaleBeginTime, presaleEndTime } = parseDeliverInfo;
      const params = {
        stockType
      };
      if (stockType === 1) {
        Object.assign(params, {
          fullPaymentPresaleDeliveryType,
          fullPaymentPresaleDeliveryTime,
          presaleTime: fullPaymentPresaleDeliveryType === 1 ? [presaleBeginTime, presaleEndTime] : []
        })
      }
      this.$refs.dialogSelectStockType.handleShow(params);
    },
    handleSelectStockType(row, deliverInfo) {
      if (row['deliverInfo'] === undefined) {
        this.$set(row, 'deliverInfo', deliverInfo)
      } else {
        row['deliverInfo'] = deliverInfo;
      }
    },
    handleSelectStockTypeSuccess(deliverInfo) {
      if (this.deliverInfoDialog.batch) {
        this.skuList.forEach(row => {
          this.handleSelectStockType(row, deliverInfo);
        });
      } else {
        this.handleSelectStockType(this.editRowData, deliverInfo);
      }
    },


    // 初始化退货地址模板
    initReturnAddressTemplate(afterSaleAddressTemplateList) {
      const platformAddressList = afterSaleAddressTemplateList;
      let productAddressList = this.self_form.afterSaleAddressConfig  || [];
      const shopList = this.shopList  || [];

      // 创建映射表
      const platformAddressMap = new Map();
      platformAddressList.forEach(item => {
        if (item.shopId) {
          platformAddressMap.set(item.shopId, {
            shopId: item.shopId,
            addressId: item.addressId || '',
            addressName: item.addressName
          });
        }
      });

      const productAddressMap = new Map();
      productAddressList.forEach(item => {
        if (item.shopId) {
          productAddressMap.set(item.shopId, {
            shopId: item.shopId,
            addressId: item.addressId || '',
            addressName: item.addressName
          });
        }
      });

      shopList.forEach(shop => {
        const shopId = shop.id;

        // 确保地址模板存储存在
        if (!this.returnAddressTemplate[shopId]) {
          this.$set(this.returnAddressTemplate, shopId, []);
        }

        // 优先级：商品配置 > 平台配置 > 保持已有值
        let finalAddress = productAddressMap.get(shopId)
          || platformAddressMap.get(shopId)
          || this.returnAddressValue[shopId]
          || null;

        // 确保地址值存储存在，且不被 null 覆盖
        if (!this.returnAddressValue[shopId]?.addressId && finalAddress) {
          this.$set(this.returnAddressValue, shopId, finalAddress);
        }

        if (finalAddress) {
          this.$set(this.returnAddressTemplate, shopId, [finalAddress]);
        }
      });
    },

    // 处理退货地址变更
    handleReturnAddressChange(shopId, addressId) {
      const selectedAddress = this.returnAddressTemplate[shopId]?.find(item => item.addressId == addressId);
      if (selectedAddress) {
        // Create a new object to ensure reactivity
        const newValue = {
          shopId: selectedAddress.shopId,
          addressId: selectedAddress.addressId,
          addressName: selectedAddress.addressName,
        };
        this.$set(this.returnAddressValue, shopId, newValue);
      } else {
        // Clear the value if no address selected
        this.$set(this.returnAddressValue, shopId, {
          shopId,
          addressId: '',
          addressName: ''
        });
      }
      console.log(shopId, addressId, cloneDeep(this.returnAddressValue), '--------')

    },

    // 获取退货地址列表
    async getReturnAddressList({shopId, userId}) {
      const cacheKey = `${shopId}_returnAddressCacheType`;

      // 已有缓存时不重复请求
      if (this.returnAddressTemplateCaches[cacheKey]) return;

      this.$set(this.selectLoading, shopId, true);
      try {
        const params = {
          userId,
          offset: 0,
          limit: 100,
          searchUsed: false,
          shopId,
        }
        const res = await getWxsphAddressList(params);
        let list = [];
        if (res && res.length) {
          list = res.map(item => ({
            shopId,
            addressId: item.addressId,
            addressName: item.name
          }));
        }

        // 如果当前已有选中的地址，确保它也在选项列表中（API可能未返回该地址）
        const currentAddress = this.returnAddressValue[shopId];
        if (currentAddress && currentAddress.addressId) {
          const findItem = list.find(item => item.addressId === currentAddress.addressId);
          if (!findItem) {
            list.unshift(currentAddress);
          } else {
            if(findItem.addressName !== currentAddress.addressName) {
              currentAddress.addressName = findItem.addressName 
            }
          }
        }
        this.$set(this.returnAddressTemplate, shopId, list)
        this.$set(this.returnAddressTemplateCaches, cacheKey, list)
      } catch (error) {
        this.$set(this.returnAddressTemplate, shopId, []);
      } finally {
        this.$set(this.selectLoading, shopId, false);
      }
    },

    // 退货地址下拉框显示变化处理
    async visibleChangeReturnAddress(shopId, userId, visible) {
      if (!visible) return;
      await this.getReturnAddressList({ shopId, userId });
    },

    // 获取退货地址配置
    handleAfterSaleAddressConfig() {
      const arr = [];
      Object.keys(this.returnAddressValue).forEach(shopId => {
        const curValue = this.returnAddressValue[shopId];
        if (curValue && curValue.addressId &&  curValue.addressName) {
          arr.push({
            shopId: curValue.shopId,
            addressId: curValue.addressId,
            addressName: curValue.addressName
          });
        }
      });
      return JSON.stringify(arr);
    },
    handleProductQuaInfos(_formdata) {
      const arr = [];
      this.productQuaInfoAttrs.forEach(item => {
        arr.push({
          qua_id: item.quaId,
          qua_url: this.self_form[`quaId_${item.quaId}`],
        })
        delete _formdata[`quaId_${item.quaId}`]
      })
      return arr;
    },
    clickTemPlateFill(row) {
        const platformCatProp = row.platformCatProp ? JSON.parse(row.platformCatProp) : [];
        this.$refs.cateprops.init();
        this.$set(this.self_form,'productFormat',platformCatProp)
    },
    getVideoInfoById(id){
      getVideoInfo([id]).then(res => {
        if(res.result === 1 && res.data){
          this.videoInfo = (res.data || []).find(i => i.videoId == id) || null
        }
      })
    },
    videoDel(data){
      this.self_form.videoId = '';
      this.videoInfo = null;
    },
    async videoUploadSuccess(data){
      this.videoInfo = data;
      if(data){
          const videoId = await editCarouselVideo({
              carouselVideoVo: data,
              baseItemId: this.baseItemId
          });
          this.self_form.videoId = videoId;
      }
    },
  },
  mounted() {
    this.getConf()
  },
};
</script>

<style lang="scss" scope>
.stockType-desc{
  line-height: 14px;
  span{
    vertical-align: middle;
  }
  ::v-deep .el-link{
    vertical-align: middle;
    line-height: 14px;
  }
}
.ship-wrp{
  .item{
    display: flex;
    margin: 8px;
  }
}
.shopname{
  display: flex;
}
.platform-info-edit-wrp {
  &.is-disabled {
    pointer-events: none;
    opacity: 0.6;
    * {
      pointer-events: none;
    }
  }
}
</style>